import { useQuery } from '@tanstack/react-query'
import { configAjax } from '../../ajax/ConfigAjax'
import { ErrorResponse } from '../../DTOs/Common/ErrorResponse'

// Note: false while the query is in flight or has failed, so a screen that cannot reach the API shows the
// simpler one-machine layout rather than a Plant Model cell whose value it has no way to derive.
export function useRehandleCollectsTruckBucketType() {
  const { data } = useQuery({
    queryKey: ['config', 'rehandle'],
    queryFn: async () => {
      const res = await configAjax.getRehandleConfig()
      if (ErrorResponse.isErrorResponse(res)) return null
      return res
    },
    staleTime: Infinity,
    gcTime: 1000 * 60 * 60 * 24 * 7,
  })

  return data?.collectsTruckBucketType ?? false
}
